import { addAuthorizationToHeader } from "./authorize";
import { BASE_PATH } from "./base";
const GET_ARCHIVED_RESOURCES_PATH = BASE_PATH + "/get-archived-resources";
export const getArchivedResources = async () => {
    const headers = new Headers();
    addAuthorizationToHeader(headers);
    return fetch(GET_ARCHIVED_RESOURCES_PATH, {
        method: "GET",
        headers,
    }).then((response) => response.json());
};
